// برچسب‌های فارسی مشترک پنل کاربر و پنل مدیر

export const SERVICE_LABEL = {
  nid: "استعلام ثبت احوال",
  shahkar: "استعلام شاهکار",
  sana: "استعلام عضویت سنا",
};

// منبع لاگ -> سرویس
export const SOURCE_SERVICE = {
  upstream: "nid", cache: "nid", online: "nid",
  shahkar: "shahkar", sana_shahkar: "shahkar",
  sana_membership: "sana", sana: "sana",
};

export const STATUS_LABEL = {
  found: "یافت شد",
  matched: "تطابق",
  not_matched: "عدم تطابق",
  sana_in: "عضو",
  sana_not_in: "غیرعضو",
  mobile_mismatch: "عدم تطابق موبایل",
  alive: "در قید حیات",
  dead: "فوت‌شده",
  not_found: "یافت نشد",
};

export const WINDOW_OPTIONS = [
  { value: "24h", label: "۲۴ ساعت" },
  { value: "7d", label: "۷ روز" },
  { value: "30d", label: "۳۰ روز" },
  { value: "all", label: "کل زمان" },
];

// مجموع تعداد بر اساس سرویس از روی by_source
export function countByService(bySource = {}) {
  const out = { nid: 0, shahkar: 0, sana: 0 };
  Object.entries(bySource).forEach(([src, n]) => {
    const svc = SOURCE_SERVICE[src] || "nid";
    out[svc] += Number(n) || 0;
  });
  return out;
}
